import { Card, CardContent, Typography, Grid, Divider, Box, Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow, Paper, } from "@mui/material";
import { useElectronicsConfiguration } from "../../context/ElectronicsConfigurationContext.tsx";

const ElectronicsSummary = () => {
  const { config: electronicsConfig } = useElectronicsConfiguration();

  const powerSupplyTableRows = [
    electronicsConfig.power_supply.dcdc24V,
    electronicsConfig.power_supply.dcdc12V,
    electronicsConfig.power_supply.dcdc5V,
    electronicsConfig.power_supply.dcdc3V3,
    electronicsConfig.power_supply.linear1,
    electronicsConfig.power_supply.linear2,
    electronicsConfig.power_supply.linear3
  ]
    .filter(supply => supply.enable)
    .map(supply => ({
      label: supply.label,
      value: ""
    }));

  const communicationTableRows = [
    electronicsConfig.communication.rs232,
    electronicsConfig.communication.rs485,
    electronicsConfig.communication.uart,
    electronicsConfig.communication.usb,
    electronicsConfig.communication.sd_card,
  ]
    .filter(comm => comm.enable)
    .map(comm => ({
      label: comm.label,
      value: ""
    }));

  const flasherTableRows = [
    electronicsConfig.flasher.stlink1,
    electronicsConfig.flasher.stlink2,
  ]
    .filter(flasher => flasher.enable)
    .map(flasher => ({
      label: flasher.label,
      value: ""
    }));

  const componentsTableRows = [
    { label: "Anzahl Widerstände", value: electronicsConfig.signal_mapping.resistor.length + electronicsConfig.custom_signals.resistor.length },
    { label: "Anzahl Schottky-Dioden", value: electronicsConfig.custom_signals.schottky.length },
  ];

  const modulesTableRows = [
    { label: "Anzahl Relais-Boards", value: electronicsConfig.modules.relais },
    { label: "Anzahl Spannungsmessboards", value: electronicsConfig.modules.voltage },
    { label: "Anzahl Strommessboards", value: electronicsConfig.modules.current },
  ].filter(row => typeof row.value === "number" && row.value > 0);

  return (
    <>
      <Typography variant="h6">Elektronik</Typography>
      <Box mt={2} />
      <Grid container spacing={2}>
        <Grid size={6}>
          <Card>
            <CardContent>
              <Typography variant="h6">Spannungsquellen</Typography>
              <Divider sx={{ my: 1 }} />
              <TableContainer component={Paper} elevation={1}>
                <Table size="small" aria-label="DUT-Anordnung">
                  <TableBody>
                    {powerSupplyTableRows.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ width: '50%' }}>{row.label}</TableCell>
                        <TableCell sx={{ width: '50%' }}>{row.value}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
          <Card>
            <CardContent>
              <Typography variant="h6">Kommunikationsschnittstellen</Typography>
              <Divider sx={{ my: 1 }} />
              <TableContainer component={Paper} elevation={1}>
                <Table size="small" aria-label="DUT-Anordnung">
                  <TableBody>
                    {communicationTableRows.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ width: '50%' }}>{row.label}</TableCell>
                        <TableCell sx={{ width: '50%' }}>{row.value}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
          <Card>
            <CardContent>
              <Typography variant="h6">Microcontroller Flasher</Typography>
              <Divider sx={{ my: 1 }} />
              <TableContainer component={Paper} elevation={1}>
                <Table size="small" aria-label="DUT-Anordnung">
                  <TableBody>
                    {flasherTableRows.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ width: '50%' }}>{row.label}</TableCell>
                        <TableCell sx={{ width: '50%' }}>{row.value}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </ Grid>
        <Grid size={6}>
          <Card>
            <CardContent>
              <Typography variant="h6">Komponenten</Typography>
              <Divider sx={{ my: 1 }} />
              <TableContainer component={Paper} elevation={1}>
                <Table size="small" aria-label="DUT-Anordnung">
                  <TableBody>
                    {componentsTableRows.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ width: '50%' }}>{row.label}</TableCell>
                        <TableCell sx={{ width: '50%' }}>{row.value}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
          <Card>
            <CardContent>
              <Typography variant="h6">Module</Typography>
              <Divider sx={{ my: 1 }} />
              <TableContainer component={Paper} elevation={1}>
                <Table size="small" aria-label="DUT-Anordnung">
                  <TableBody>
                    {modulesTableRows.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ width: '50%' }}>{row.label}</TableCell>
                        <TableCell sx={{ width: '50%' }}>{row.value}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  )
};

export default ElectronicsSummary;